/**
 * Farm Management
 * Handles adding, editing, and deleting farms on the client edit page
 */
import * as bootstrap from 'bootstrap';

document.addEventListener("DOMContentLoaded", function () {
	const farmsCard = document.getElementById("farmsCard");

	// Only run on pages with the farms card
	if (!farmsCard) return;

	const clientId = farmsCard.dataset.clientId;
	const farmModal = document.getElementById("farmModal");
	const deleteFarmModal = document.getElementById("deleteFarmModal");

	if (!farmModal || !deleteFarmModal) return;

	const farmModalInstance = new bootstrap.Modal(farmModal);
	const deleteFarmModalInstance = new bootstrap.Modal(deleteFarmModal);

	// Form elements
	const farmForm = document.getElementById("farmForm");
	const farmIdInput = document.getElementById("farmId");
	const farmNameInput = document.getElementById("farmName");
	const farmModalTitle = document.getElementById("farmModalTitle");
	const saveFarmBtn = document.getElementById("saveFarmBtn");
	const addFarmBtn = document.getElementById("addFarmBtn");

	// Delete modal elements
	const deleteFarmNameSpan = document.getElementById("deleteFarmName");
	const confirmDeleteFarmBtn = document.getElementById("confirmDeleteFarmBtn");

	let farmToDelete = null;

	// Add Farm button click
	addFarmBtn.addEventListener("click", function (e) {
		e.preventDefault();
		openFarmModal();
	});

	// Save Farm button click
	saveFarmBtn.addEventListener("click", function () {
		saveFarm();
	});

	// Confirm Delete button click
	confirmDeleteFarmBtn.addEventListener("click", function () {
		if (farmToDelete) {
			deleteFarm(farmToDelete);
		}
	});

	// Event delegation for edit and delete buttons
	document.getElementById("farmsList").addEventListener("click", function (e) {
		const editBtn = e.target.closest(".edit-farm-btn");
		const deleteBtn = e.target.closest(".delete-farm-btn");

		if (editBtn) {
			e.preventDefault();
			const farmItem = editBtn.closest(".farm-item");
			const farmId = farmItem.dataset.farmId;
			openFarmModal(farmId);
		}

		if (deleteBtn) {
			e.preventDefault();
			const farmItem = deleteBtn.closest(".farm-item");
			const farmId = farmItem.dataset.farmId;
			const farmName = farmItem.querySelector(".farm-name").textContent;
			openDeleteModal(farmId, farmName);
		}
	});

	// Open farm modal (for add or edit)
	function openFarmModal(farmId = null) {
		// Reset form
		farmForm.reset();
		farmIdInput.value = "";

		// Hide current image preview
		const currentImageContainer = document.getElementById("currentReferenceImage");
		if (currentImageContainer) {
			currentImageContainer.style.display = "none";
		}

		if (farmId) {
			// Edit mode - fetch farm data
			farmModalTitle.textContent = "Edit Farm";
			fetchFarm(farmId).then((farm) => {
				if (farm) {
					farmIdInput.value = farm.id;
					farmNameInput.value = farm.farm_name;
					document.querySelector(`input[name="shed_type"][value="${farm.shed_type}"]`).checked = true;
					document.getElementById("farmAddressLine1").value = farm.address_line_1 || "";
					document.getElementById("farmAddressLine2").value = farm.address_line_2 || "";
					document.getElementById("farmCity").value = farm.city || "";
					document.getElementById("farmState").value = farm.state || "";
					document.getElementById("farmPostcode").value = farm.postcode || "";

					// Show current reference image if exists
					if (farm.reference_image) {
						const currentImageContainer = document.getElementById("currentReferenceImage");
						const currentImagePreview = document.getElementById("currentReferenceImagePreview");
						if (currentImageContainer && currentImagePreview) {
							currentImagePreview.src = farm.reference_image;
							currentImageContainer.style.display = "block";
						}
					}
				}
			});
		} else {
			// Add mode
			farmModalTitle.textContent = "Add Farm";
		}

		farmModalInstance.show();
	}

	// Open delete confirmation modal
	function openDeleteModal(farmId, farmName) {
		farmToDelete = farmId;
		deleteFarmNameSpan.textContent = farmName;
		deleteFarmModalInstance.show();
	}

	// Fetch a single farm
	async function fetchFarm(farmId) {
		try {
			const response = await fetch(`/api/farms/${farmId}/`, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
				},
			});

			if (!response.ok) {
				throw new Error("Failed to fetch farm");
			}

			return await response.json();
		} catch {
			alert("Failed to load farm data");
			return null;
		}
	}

	// Save farm (create or update)
	async function saveFarm() {
		const farmId = farmIdInput.value;
		const farmName = farmNameInput.value.trim();

		if (!farmName) {
			alert("Please enter a farm name");
			farmNameInput.focus();
			return;
		}

		const shedTypeInput = document.querySelector('input[name="shed_type"]:checked');
		const referenceImageInput = document.getElementById("farmReferenceImage");

		// Use FormData to support file uploads
		const formData = new FormData();
		formData.append("farm_name", farmName);
		formData.append("shed_type", shedTypeInput ? shedTypeInput.value : "STANDARD");
		formData.append("address_line_1", document.getElementById("farmAddressLine1").value);
		formData.append("address_line_2", document.getElementById("farmAddressLine2").value);
		formData.append("city", document.getElementById("farmCity").value);
		formData.append("state", document.getElementById("farmState").value);
		formData.append("postcode", document.getElementById("farmPostcode").value);

		// Add reference image if selected
		if (referenceImageInput && referenceImageInput.files.length > 0) {
			formData.append("reference_image", referenceImageInput.files[0]);
		}

		try {
			const csrfToken = document.querySelector("[name=csrfmiddlewaretoken]").value;
			let url, method;

			if (farmId) {
				// Update existing farm
				url = `/api/farms/${farmId}/`;
				method = "PUT";
			} else {
				// Create new farm
				url = `/api/clients/${clientId}/farms/`;
				method = "POST";
			}

			const response = await fetch(url, {
				method: method,
				headers: {
					"X-CSRFToken": csrfToken,
				},
				body: formData,
			});

			if (!response.ok) {
				const errorData = await response.json();
				throw new Error(errorData.error || "Failed to save farm");
			}

			// Close modal and refresh the page to show updated list
			farmModalInstance.hide();
			location.reload();
		} catch (error) {
			alert(error.message || "Failed to save farm");
		}
	}

	// Delete farm
	async function deleteFarm(farmId) {
		try {
			const csrfToken = document.querySelector("[name=csrfmiddlewaretoken]").value;

			const response = await fetch(`/api/farms/${farmId}/`, {
				method: "DELETE",
				headers: {
					"Content-Type": "application/json",
					"X-CSRFToken": csrfToken,
				},
			});

			if (!response.ok) {
				const errorData = await response.json();
				throw new Error(errorData.error || "Failed to delete farm");
			}

			// Close modal and remove the farm item from DOM
			deleteFarmModalInstance.hide();
			farmToDelete = null;

			// Remove the farm element from the list
			const farmItem = document.querySelector(`.farm-item[data-farm-id="${farmId}"]`);
			if (farmItem) {
				farmItem.remove();
			}

			// Show "no farms" message if list is empty
			const farmsList = document.getElementById("farmsList");
			if (!farmsList.querySelector(".farm-item")) {
				farmsList.innerHTML = '<p class="text-muted" id="noFarmsMessage">No farms added yet. Click "Add Farm" to create one.</p>';
			}
		} catch (error) {
			alert(error.message || "Failed to delete farm");
		}
	}
});
